export { default } from './CreateProduct';
